var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 92,
    viewBox: "0 0 52 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 46V66.1C1.00239 72.7297 3.63707 79.0871 8.32496 83.775C13.0129 88.4629 19.3703 91.0976 26 91.1V91.1C32.6297 91.0976 38.9871 88.4629 43.675 83.775C48.3629 79.0871 50.9976 72.7297 51 66.1V46",
    stroke: "url(#paint0_linear_930_2518)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46.1V26C50.9976 19.3703 48.3629 13.0129 43.675 8.32496C38.9871 3.63707 32.6297 1.00239 26 1V1C19.3703 1.00239 13.0129 3.63707 8.32496 8.32496C3.63707 13.0129 1.00239 19.3703 1 26V46.1",
    stroke: "url(#paint1_linear_930_2518)",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_930_2518",
    x1: 13.7187,
    y1: 53.1077,
    x2: 71.5022,
    y2: 90.0822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_930_2518",
    x1: 13.7187,
    y1: 8.1077,
    x2: 71.5022,
    y2: 45.0822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollBottom);
export default __webpack_public_path__ + "static/media/scroll-bottom.cdd5364e42cf6a3459ba8db28afb2226.svg";
export { ForwardRef as ReactComponent };